import React, { useEffect, useState } from "react";
import { CreacionTitulosService } from "../../../../_services/creaciontitulos.service";
import { Tabla } from "../../../../components/Table/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import TitulosFilter from "./TitulosFilters";
import DownloadExcel from "./DownloadExcel";
// import { Eye, Edit, Printer } from "react-feather";
import { Edit, Printer } from "react-feather";
import InfoTitulosModal from "./InfoTitulosModal";
import styled from "styled-components";

const ListTitleHome = () => {
  const [titleHasData, setTitleHasData] = useState(true);
  const [titles, setTitles] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    abogadoCodExt: "",
    order: "asc",
  });
  const [abogadosList, setAbogadosList] = useState({});
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const getFilterData = async () => {
      let res = await CreacionTitulosService.getAbogadosInfoFilter();
      const resDecorated = res.data.map((res) => {
        return {
          value: res.codexterno,
          label: `${res.codexterno} - ${res.apellido}, ${res.nombre}`,
        };
      });
      setAbogadosList(resDecorated);
    };
    getFilterData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      const queryParams = buildQueryParams();
      let res = await CreacionTitulosService.getTitlesInfo(queryParams);
      const dataDecorator = formatData(res.data);
      setTitles(dataDecorator);
    };
    getData();
  }, [filters]);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const buildQueryParams = () => {
    const params = new URLSearchParams();

    if (filters.startDate) params.append("startDate", filters.startDate);
    if (filters.endDate) params.append("endDate", filters.endDate);
    if (filters.abogadoCodExt)
      params.append("abogadoCodExt", filters.abogadoCodExt);
    params.append("order", filters.order);

    return params.toString();
  };

  const handleShow = (e) => {
    setData(e);
    setShow(true);
  };

  const handlePrintTitle = async (titleNumber) => {
    try {
      const response = await CreacionTitulosService.printTitle(
        `numberTitle=${titleNumber}`
      );

      // Extraer el filename desde headers
      const disposition = response.headers["content-disposition"];
      let filename = "archivo.pdf";

      if (disposition && disposition.includes("filename=")) {
        filename = disposition
          .split("filename=")[1]
          .split(";")[0]
          .replace(/["']/g, "");
      }

      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      setTitleHasData(false);
      console.log("Error en el submit", error);
    }
  };

  const columns = [
    {
      title: "Título Nº",
      dataIndex: "numTitulo",
    },
    {
      title: "Nombre Abogado",
      dataIndex: "nomApeAbo",
    },
    {
      title: "Cód. Externo",
      dataIndex: "abo_codexterno",
    },
    {
      title: "Recurso",
      dataIndex: "recurso",
    },
    {
      title: "Nombre Creador",
      dataIndex: "nomApeCrea",
    },
    {
      title: "Fecha Creación",
      dataIndex: "fechaCreac",
    },
    {
      title: "Hora Creación",
      dataIndex: "horaCreac",
    },
    {
      title: "Acción",
      render: (a, row) => {
        return (
          <div className="d-flex">
            <Edit
              className="mx-2 action-table"
              onClick={() => handleShow(row.numTitulo)}
            />
            <Printer
              className="mx-2 action-table"
              onClick={() => handlePrintTitle(row.numTitulo)}
            />
          </div>
        );
      },
    },
  ];

  const handleCloseModal = () => {
    setShow(false);
    // setRestart(!restart);
  };

  const handleClosePrint = () => {
    setTitleHasData(true);
  };

  const formatData = (arrayData = []) => {
    try {
      return arrayData.map((item) => {
        return {
          numTitulo: item.num_titulo,
          nomApeAbo: `${item.abogado.nombre} ${item.abogado.apellido}`,
          abo_codexterno: item.abo_codexterno,
          recurso: item.recurso,
          nomApeCrea: `${item.usuario.nombre} ${item.usuario.apellido}`,
          fechaCreac: item.fecha_creacion,
          horaCreac: item.hora_creacion,
        };
      });
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  return (
    <div className="container mt-5">
      <div className="button-filter">
        {showFilter ? (
          <Button
            variant="danger"
            onClick={() => setShowFilter(false)}
            className="danger-button d-flex align-items-center"
            style={{ maxWidth: 105 }}
          >
            <FontAwesomeIcon icon={faArrowDown} size="1x" />
            <span className="ml-2">Ocultar</span>
          </Button>
        ) : (
          <Button
            onClick={() => setShowFilter(true)}
            className="custom-button d-flex align-items-center"
            style={{ maxWidth: 105 }}
          >
            <FontAwesomeIcon icon={faArrowUp} size="1x" />
            <span className="ml-2">Mostrar</span>
          </Button>
        )}
      </div>
      <TitulosFilter
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        style={{ marginBottom: "30px" }}
        onFilterChange={handleFilterChange}
        abogadosList={abogadosList}
      />
      <div>
        <h3 className="text-center mb-4">Títulos Creados</h3>
        <DownloadExcel
          data={titles}
          columns={columns}
          nameFile={`tituloscreados_${new Date().getTime()}.xlsx`}
        />
      </div>
      {formatData ? <Tabla dataList={titles} columns={columns} /> : null}
      {show ? (
        <InfoTitulosModal
          show={show}
          numTitulo={data}
          handleCloseModal={handleCloseModal}
        />
      ) : (
        <></>
      )}
      {titleHasData ? (
        <></>
      ) : (
        <ModalOverlay>
          <ModalContainer>
            <ModalNoInfo>
              <ModalTitle>Título creado anteriormente.</ModalTitle>
              <ModalTitle>No se puede imprimir nuevamente.</ModalTitle>
              <ButtonClose
                style={{ maxWidth: 190 }}
                variant="danger"
                onClick={handleClosePrint}
              >
                <span>Cerrar</span>
              </ButtonClose>
            </ModalNoInfo>
          </ModalContainer>
        </ModalOverlay>
      )}
    </div>
  );
};

export default ListTitleHome;

const ModalOverlay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
`;

const ModalContainer = styled.div`
  background: white;
  padding: 30px;
  width: 80%;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`;

const ModalTitle = styled.h2`
  text-align: center;
`;

const ModalNoInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ButtonClose = styled.button`
  margin: 20px;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  background-color: ${({ variant, disabled }) =>
    disabled ? "#ccc" : variant === "danger" ? "#dc3545" : "#007bff"};
  color: white;

  &:hover {
    opacity: ${({ disabled }) => (disabled ? "1" : "0.7")};
  }
`;
